export enum DeliveryState {
  Loading = 'Loading',
  AddAddress = 'AddAddress',
  ShowAddress = 'ShowAddress',
  ShowMobileAddress = 'ShowMobileAddress',
}
